// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".czt-list>li{line-height:1.75;list-style:none}.czt-list>li::before{content:\"\";border-color:#ff0018;border-style:solid;border-width:5px;display:block;height:0;width:0;float:left;margin-right:10px;margin-top:.55em}", ""]);
// Exports
module.exports = exports;
